export default {"src":"/_next/static/media/comments_regular.4c1c1902.svg","height":24,"width":24};